module.exports = __webpack_public_path__ + "log grey-16cca34399f707df3175.svg";